import { render, staticRenderFns } from "./ModalCreateInvoiceGroupDraft.vue?vue&type=template&id=5846e9d4&"
import script from "./ModalCreateInvoiceGroupDraft.vue?vue&type=script&lang=js&"
export * from "./ModalCreateInvoiceGroupDraft.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateInvoiceGroupDraft.vue?vue&type=style&index=0&id=5846e9d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports